import React from 'react';
import Navbar from './navbar';
import Footer from './footer';
import './privacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <h1>Privacy Policy</h1>
          <p>Last Updated: May 2024</p>
        </div>

        <div className="privacy-policy-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to Immiget Global. We respect your privacy and are committed to protecting your personal data. 
              This privacy policy explains how we collect, use, disclose, and safeguard your information when you visit our website or 
              use our immigration consultation services.
            </p>
            <p>
              Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, 
              please do not access the site or use our services.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>We may collect several types of information from and about users of our website and services, including:</p>
            <ul>
              <li>
                <strong>Personal Identification Information:</strong> This may include your name, postal address, email address, telephone number, 
                date of birth, nationality, passport details, and other similar information required for immigration services.
              </li>
              <li>
                <strong>Professional Information:</strong> This may include your employment history, educational qualifications, skills assessment 
                information, and other relevant professional details.
              </li>
              <li>
                <strong>Financial Information:</strong> This may include payment details and transaction information.
              </li>
              <li>
                <strong>Technical Information:</strong> This may include your IP address, browser type and version, time zone setting, 
                operating system, and platform when you access our website.
              </li>
              <li>
                <strong>Usage Information:</strong> This may include information about how you use our website and services.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. How We Collect Your Information</h2>
            <p>We collect information through various methods, including:</p>
            <ul>
              <li>Direct interactions when you fill in forms on our website or correspond with us</li>
              <li>Automated technologies or interactions as you navigate through our website</li>
              <li>Third parties or publicly available sources</li>
            </ul>
          </section>

          <section>
            <h2>4. How We Use Your Information</h2>
            <p>We may use the information we collect about you for various purposes, including:</p>
            <ul>
              <li>Providing and maintaining our services</li>
              <li>Processing your immigration applications</li>
              <li>Responding to your inquiries and requests</li>
              <li>Sending you updates and information about your applications</li>
              <li>Improving our website and services</li>
              <li>Complying with legal obligations</li>
              <li>Marketing and promotional communications (where you have opted in)</li>
            </ul>
          </section>

          <section>
            <h2>5. Disclosure of Your Information</h2>
            <p>We may share your personal information with:</p>
            <ul>
              <li>Government departments and immigration authorities for processing your applications</li>
              <li>Professional advisers including lawyers, accountants, and insurers</li>
              <li>Service providers who perform functions on our behalf</li>
              <li>Third parties to whom we may choose to sell, transfer, or merge parts of our business</li>
            </ul>
            <p>
              We require all third parties to respect the security of your personal data and to treat it in accordance 
              with the law.
            </p>
          </section>

          <section>
            <h2>6. Data Security</h2>
            <p>
              We have implemented appropriate security measures to prevent your personal data from being accidentally lost, 
              used, or accessed in an unauthorized way, altered, or disclosed. We limit access to your personal data to 
              those employees, agents, contractors, and other third parties who have a business need to know.
            </p>
          </section>

          <section>
            <h2>7. Data Retention</h2>
            <p>
              We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, 
              including for the purposes of satisfying any legal, accounting, or reporting requirements.
            </p>
          </section>

          <section>
            <h2>8. Your Legal Rights</h2>
            <p>Depending on your location, you may have various rights regarding your personal data, including:</p>
            <ul>
              <li>The right to access your personal data</li>
              <li>The right to rectification of your personal data</li>
              <li>The right to erasure of your personal data</li>
              <li>The right to restrict processing of your personal data</li>
              <li>The right to data portability</li>
              <li>The right to object to processing of your personal data</li>
            </ul>
          </section>

          <section>
            <h2>9. Children's Privacy</h2>
            <p>
              Our website and services are not intended for children under 16 years of age. We do not knowingly collect 
              personal information from children under 16. If you are a parent or guardian and believe we may have collected 
              information about a child, please contact us.
            </p>
          </section>

          <section>
            <h2>10. Changes to Our Privacy Policy</h2>
            <p>
              We may update our privacy policy from time to time. We will notify you of any changes by posting the new 
              privacy policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
            </p>
            <p className="contact-info">
              Immiget Global<br />
              Email: info@immigetglobal.com<br />
              Phone: +61 420 340 811
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;